module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAASNJREFUSA3tlk0OgjAQhUm8gyZcw6Pphg2H8TQcQD2CC9e6xvdKnymk/E3LwsRJpqOdmffRAg1F8bctd6Bt2zP8Aj+kcqjhtU5RLSR38DecdoOboeyF3+G0F3w3Bq1cSTeYoGgljL2yKgrTJKpqVSKyca/cXGSt70FwVs/1uDxKV0PRY4PpitZAk2Ej0CuFlVP0MOZky7ZRAsMIlXB7e1DkuI35YILHoJvBJqD5VyaY4mCl+Oss7Z5JPBYhz5f62XHcyN/mEynG+M5RGK7jytH8wLm8UArCQxif3PDpzQeNwbTs7NApWHboElg26BpYMtQCM0NTYCYogA1cZj5BIBC+Mo0uphdRxG+ah6eZYRINoNQc/aYpkTyqKTVSC16m6vxW/wd6LOqIFWkRlgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-close.png
// module id = wOFH
// module chunks = 0